import { ErrorMessage } from "./ErrorMessage";
import { Field } from "./Field";
import { Input } from "./Input";
import { Label } from "./Label";
import { Select } from "./Select";
import { Option } from "./Option";

export const Form = {
  Label,
  Input,
  ErrorMessage,
  Field,
  Select,
  Option,
}